<template>
  <page-view :title="true">
    <a-card :bordered="false">
      <div v-if="showGoods">
        <div class="nav">
          <span class="title">套餐信息</span>
          <span class="remark"></span>
        </div>
        <div class="body">
          <div
            @click="checkGoods(index, item)"
            class="option"
            :class="[selectIndex == index ? 'active' : '']"
            v-for="(item, index) in goodsList"
            :key="index"
          >
            <div class="up" :class="[selectIndex == index ? 'active' : '']">
              <div>{{ item.descript }}</div>
              <span>{{ item.salePrice }}</span>
              <span class="unit" :class="[selectIndex == index ? 'active' : '']"
                >元</span
              >
            </div>
            <div class="down" :class="[selectIndex == index ? 'active' : '']">
              <span>{{ item.value }}</span>
              <span class="unit" :class="[selectIndex == index ? 'active' : '']"
                >份</span
              >
            </div>
            <span class="hot" v-if="item.isHot == 'T'">HOT</span>
            <div class="rotator" v-if="item.isFirstRecharge == 'T'">
              首充特惠
            </div>
          </div>
        </div>
        <div v-if="showInput" class="quantity">
          <span class="span">份数：</span>
          <div class="input">
            <a-input
              type="number"
              :min="1"
              suffix="份"
              v-model="formData.quantity"
              placeholder="请输入份数"
            ></a-input>
          </div>
        </div>
      </div>
      <div v-else class="box">
        <div class="payment-header">
          <span class="payment-title">扫一扫付款</span>
          <span class="payment-money">{{ payInfo.amount }}(元)</span>
        </div>
        <div class="qr-box">
          <vue-qr :text="payInfo.qrCode" :size="200"></vue-qr>
          <div class="explain">
            <img
              src="https://t.alipayobjects.com/images/T1bdtfXfdiXXXXXXXX.png"
              alt="扫一扫标识"
            />
            <div style="padding-left: 5px;">
              打开手机支付宝
              <br />
              扫一扫继续付款
            </div>
          </div>
          <div class="timeout" v-if="timeoutFlag">
            <span>二维码已过期</span>
          </div>
        </div>
        <div class="count-down">
          <span>请于</span>
          <count-down
            color="#FFFFFF"
            background-color="#007AFF"
            border-color="#007AFF"
            :show-colon="false"
            :show-day="false"
            :second="payInfo.second"
            @timeup="timeup"
          />
          <span>内支付</span>
        </div>

        <div class="notice-tip">
          <!-- <div class="prompt">
            <span class="text">提示</span>
          </div> -->
          <div
            class="progress-item"
            :key="index"
            v-for="(item, index) in stepList"
          >
            <a-icon type="check-circle" v-if="item.state == 1" />
            <!-- <a-button type="primary" size="small" v-if="item.state == 1" :loading="item.state == 0">
            </a-button> -->
            <a-spin :indicator="true" v-else />
            <p style="padding-left: 10px;padding-top: 10px;">
              {{ item.message }}
            </p>
          </div>
        </div>
      </div>

      <div class="operation">
        <a-button style="margin-left: 8px" @click="back">返回</a-button>
        <a-button
          type="primary"
          v-if="showGoods"
          style="margin-left: 8px"
          :loading="loading"
          @click="pay"
          >确认购买</a-button
        >
      </div>
    </a-card>
  </page-view>
</template>

<script>
import { PageView } from "@/layouts";
import VueQr from "vue-qr";
import CountDown from "../../../components/CountDown/CountDown.vue";
export default {
  name: "AddContractOrder",
  components: {
    PageView,
    VueQr,
    CountDown
  },
  data() {
    return {
      userInfo: null,
      goodsList: [],
      selectIndex: -1,
      selectItem: null,
      showGoods: true,
      showInput: false,
      loading: false,
      formData: {
        merchantNo: "",
        saleType: "BUY",
        orderType: "C",
        salesChannel: "alipay_qr",
        type: "",
        goodsCode: "",
        quantity: 1
      },
      payInfo: {},
      timeoutFlag: false,
      step: 0, //步骤
      stepList: [{ state: 0, message: "等待发起支付请求" }],
      orderState: "notexist", // 订单不存在(未创建)notexist 等待用户支付wait 支付成功success 交易结束finished 订单已关闭close
      orderStateMessage: "",
      timer: null
    };
  },
  created() {
    this.userInfo = this.$store.getters.userInfo;
    this.listContractGoodsBase();
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  watch: {
    step: {
      handler() {
        this.pushStep();
      }
    }
  },
  methods: {
    async listContractGoodsBase() {
      this.$http.roomBksApi
        .listContractGoodsBase({ sta: "I", isHalt: "F" })
        .then(res => {
          if (res.result == 0) {
            this.goodsList = res.resultObject;
          }
        });
    },
    back() {
      this.$router.push({
        name: "ContractOrderList"
      });
    },
    checkGoods(index, item) {
      this.selectIndex = index;
      this.selectItem = item;
      this.formData.type = item.type;
      this.formData.goodsCode = item.code;
      if (item.type == "single") {
        this.showInput = true;
      } else {
        this.showInput = false;
      }
    },
    pay() {
      if (this.selectIndex < 0) {
        this.$message.info("请选择套餐");
        return;
      }
      if (this.formData.type == "single") {
        if (this.formData.quantity < 0) {
          this.$message.info("请输入正确的合同份数");
          return;
        }
      }
      this.formData.merchantNo = this.userInfo.merchantNo;
      this.loading = true;
      this.$http.roomBksApi
        .onlineMerchantOrder(this.formData)
        .then(res => {
          this.loading = false;
          if (res.result == 0) {
            this.showGoods = false;
            this.payInfo = res.resultObject;
            this.searchState();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    searchState() {
      this.timer = setTimeout(() => {
        this.queryResult();
        if (this.step > 1) {
          clearTimeout(this.timer);
          return;
        }
        this.searchState();
      }, 2000);
    },
    queryResult() {
      this.$http.roomBksApi
        .alipayOrderQuery({ orderNo: this.payInfo.orderNo })
        .then(res => {
          this.orderState = res.msg;
          if (this.orderState == "success") {
            this.orderStateMessage = "支付成功";
            this.stop();
          } else if (this.orderState == "finished") {
            this.orderStateMessage = "交易结束";
            this.stop();
          } else if (this.orderState == "close") {
            this.orderStateMessage = "订单已关闭";
            this.stop();
          } else if (this.orderState == "wait") {
            this.step = 1;
          }
        });
    },
    pushStep() {
      for (var i = 0; i < this.stepList.length; i++) {
        this.stepList[i].state = 1;
      }
      if (this.step == 1) {
        let obj = {};
        obj.state = 0;
        obj.message = "等待付款中...";
        this.stepList.push(obj);
      } else if (this.step == 2) {
        let obj = {};
        obj.state = 1;
        obj.message = this.orderStateMessage;
        this.stepList.push(obj);
      }
    },
    timeup() {
      //倒计时结束
      this.timeoutFlag = true;
    },
    stop() {
      this.step = 2;
      this.payInfo.second = 0;
    }
  }
};
</script>

<style lang="less">
.operation {
  text-align: center;
  margin-top: 50px;
}
.nav {
  margin: 10px;
  height: 50px;
  line-height: 50px;
  .title {
    font-size: 14px;
    font-weight: bold;
  }
  .remark {
    font-size: 12px;
    color: grey;
    padding-left: 10px;
  }
}
.body {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin: 0 10px;
  .option.active {
    border: 1px solid #fe5983;
  }
  .option {
    overflow: hidden;
    width: 110px;
    height: 110px;
    border: 1px solid #f2f2f2;
    margin: 10px 20px;
    position: relative;
    .up {
      height: 70%;
      z-index: 10;
      border-bottom-left-radius: 50%;
      border-bottom-right-radius: 50%;
      // border: 1px solid blue;
      position: absolute;
      left: 0;
      right: 0;
      background-color: #ffffff;
      text-align: center;
      // line-height: 70px;
      font-weight: bold;
      .unit {
        color: grey;
        padding-left: 2px;
        font-size: 12px;
      }
      .unit.active {
        color: #fe5983;
      }
    }
    .up.active {
      color: #fe5983;
    }
    .down {
      height: 50%;
      background-color: #f2f2f2;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      text-align: center;
      font-size: 10px;
      line-height: 80px;
      .unit {
        color: grey;
        padding-left: 2px;
      }
      .unit.active {
        color: #ffffff;
      }
    }
    .down.active {
      background-color: #fe5983;
      color: #ffffff;
    }
    .hot {
      position: absolute;
      left: 0;
      top: 0;
      font-size: 12px;
      background-color: #fe5983;
      z-index: 11;
      color: #ffffff;
      padding: 2px 8px;
      font-style: italic;
      border-top-right-radius: 10px;
      border-bottom-left-radius: 10px;
    }
    .rotator {
      transform: rotate(45deg);
      width: 70px;
      font-size: 10px;
      z-index: 11;
      position: absolute;
      line-height: 18px;
      top: 11px;
      right: -15px;
      background-color: #fe5983;
      color: #ffffff;
      text-align: center;
    }
  }
}
.quantity {
  display: flex;
  align-items: center;
  margin: 10px 15px 10px;
  .span {
    font-weight: bold;
  }
  .input {
    border-bottom: 1px solid #d9d9d9;
    width: 200px;
    .ant-input {
      border: none;
    }
  }
}

.box {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.payment-header {
  text-align: center;
  .payment-title {
    font-size: 16px;
    display: block;
  }
  .payment-money {
    font-size: 18px;
    color: #d44d44;
    font-weight: bold;
    display: block;
    margin: 10px 0;
  }
}

.qr-box {
  padding: 10px;
  border: 1px solid #d3d3d3;
  box-shadow: 1px 1px 1px #ccc;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  .explain {
    margin-top: 15px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    color: #4d4d4d;
    line-height: 18px;
  }

  .timeout {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.95);
    color: #d44d44;
    line-height: 200px;
    text-align: center;
    z-index: 1;
    font-size: 14px;
  }
}

.count-down {
  font-size: 14px;
  margin: 10px auto 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    font-size: 12px;
    line-height: 24px;
  }
}

.notice-tip {
  height: auto;
  margin-top: 30px;
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  .prompt {
    display: flex;
    align-items: center;
    .text {
      padding-left: 10px;
      // color: #de8c17;
      font-size: 14px;
      font-weight: bold;
    }
  }
  .progress-item {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}
</style>
